import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService, CommonService, LoginService, 
  PageService, AmbientesService, InterceptorProvider, MessagesService, SpinnerService } from './service.index';
import { HttpClientModule } from '@angular/common/http';
// import { FormIOService } from './common/formIO.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './common/error.service';
import { ErrorCatchService } from './common/error-catch.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
  ],
  providers:[
    SessionService,
    CommonService,
    LoginService,
    PageService,
    AmbientesService,
    MessagesService,
    SpinnerService,
    ErrorCatchService,
    InterceptorProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    }
  ]
})
export class ServiceModule { }
